import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { PromPayStateData } from './types';

const initialState: PromPayStateData = {
	data: { data: { message: '', error: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchPromPay = createAsyncThunk(
	'api/fetchPromPay',
	({ sessionId, payId }: { sessionId: string; payId: string }) => api.fetchPromPay(sessionId, payId),
);

const promPaySlice = createSlice({
	name: 'promPay',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchPromPay.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchPromPay.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchPromPay.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default promPaySlice.reducer;
